export type WorkspaceRefSource = { uuid: string; name: string }

const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{0,63}$/
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const isUrlSlug = (name: string): boolean => SLUG_PATTERN.test(name) && !UUID_PATTERN.test(name)

export const workspaceRefOf = ({ uuid, name }: WorkspaceRefSource): string =>
  isUrlSlug(name) ? name : uuid
